import { setLanguageUrl } from "../../Comman/apiEndPoints";
import varAxios from "../../Comman/axios";

export const GET_FOOTER_TEXT = "(superadminlayout) GET FOOTER TEXT";

export function getFooterText() {
    return {
        type: GET_FOOTER_TEXT,
        text: '© 2019, made with favorite by Creative Tim for a better web.'
    }
}
export function setTranslateLang(lang){
    let requestPayload = {
        Language : lang
    }
    return (dispatch) => {
        return varAxios.post(setLanguageUrl, requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                if(response.data.statusCode == 200){
                    window.location.reload(true);
                }      
            })
            .catch((error) => {
                console.log(error)
            })
    }
}